// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3GgCf","onScrollDown":"Header_onScrollDown__2_OKK","onScrollUp":"Header_onScrollUp__3TQcC"};